export const leadership = [
  {
    id: "rbc-student-representative",
    role: "Student Representative",
    organization: "Royal Bank of Canada",
    team: "Innovation & Technology",
    period: "Aug 2025 — Dec 2025",
    location: "Toronto, ON",
    highlights: [
      "Organized and led career development workshops and networking events for 60+ peers, connecting students with RBC professionals and fostering industry readiness.",
      "Introduced new event formats (peer mentoring, technical skill sessions), boosting engagement and strengthening the student community.",
    ],
  },
  {
    id: "innis-portfolio-director",
    role: "Off-Campus Portfolio Director",
    organization: "University of Toronto",
    team: "Innis College",
    period: "Aug 2023 — May 2024",
    location: "Toronto, ON",
    highlights: [
      "Coordinated networking dinners and social programs for 30+ students, driving a 25% increase in community engagement and cross-college participation.",
    ],
  },
];
